import type { ComponentProps, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { SecondaryButton } from 'shared/components/button'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'

type SecondaryButtonProps = ComponentProps<typeof SecondaryButton>

export const SecondaryButtonWithCustomTheme = ({
  className,
  ...restProps
}: SecondaryButtonProps): ReactNode => (
  <SecondaryButton
    className={twMerge(
      `border-THEME-primary! bg-THEME-block-background! text-THEME-primary! hover:border-THEME-block-background! hover:bg-THEME-primary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:text-THEME-disabled!`,
      addPublicCustomClassNamePrefix(['course__button', 'course__button--secondary']),
      className,
    )}
    {...restProps}
  />
)
